import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-col">
            <div className="footer-logo">
              <span className="material-symbols-outlined">security</span>
              <span>RISQLY</span>
            </div>
            <p className="footer-tagline">Advancing Transparency in Vendor Cyber Risk</p>
          </div>
          <div className="footer-col">
            <h4>Resources</h4>
            <ul>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/information-security-policy">Security Policy</Link></li>
              <li><Link to="/shared-data-policy">Shared Data Policy</Link></li>
              <li><Link to="/ethics-framework">Ethics Framework</Link></li>
              <li><Link to="/community-support">Community Support</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>About</h4>
            <ul>
              <li><Link to="/about-risqly">About Risqly Cybersecurity</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li>
                <a href="https://risqly.net/company/Risqly" rel="noopener noreferrer">
                  View our Risqly profile
                </a>
              </li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 RISQLY CYBERSECURITY</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
